<template>
  <l-layout :layout="['xs12']">
    <v-card>
      <l-data-table
        :headers="header"
        ref="templateList"
        title-text="消息模板列表"
        :get-data-func="getTemplateList"
        clickable
        @click:row="getDetails($event.item)">
        <template slot="row-action" slot-scope="{item}">
          <td @click.stop class="px-0 mx-0 text-xs-center">
            <v-tooltip left>
              <v-btn @click="deleteTemplateConfirm(item)" slot="activator" icon>
                <v-icon small>$vuetify.icons.delete</v-icon>
              </v-btn>
              <span>删除消息模板</span>
            </v-tooltip>
            <v-tooltip left>
              <v-btn @click="sendDialog = {activate: true, item: item}" slot="activator" icon>
                <v-icon small>mdi-email</v-icon>
              </v-btn>
              <span>发送消息</span>
            </v-tooltip>
          </td>
        </template>
      </l-data-table>
      <l-fixed-btn
        @click="addTemplate"
        icon="$vuetify.icons.add"
      ></l-fixed-btn>
    </v-card>
    <v-dialog max-width="800px" persistent scrollable v-model="sendDialog.activate">
      <send-message-content
        :item="sendDialog.item"
        @cancel="sendDialog = {activate: false, item: {}}"
        v-if="sendDialog.activate"
      ></send-message-content>
    </v-dialog>
  </l-layout>
</template>

<script>
import sendMessageContent from './sendMessageContent'
export default {
  name: 'MessageTemplate',
  components: {
    sendMessageContent
  },
  data () {
    return {
      header: [
        {text: '模板名称', value: 'name', align: 'left', sortable: false},
        {text: '创建者', value: 'creator', align: 'left', sortable: false},
        {text: '创建时间', value: 'creationTime', align: 'left', sortable: true, f: (v) => (this.$L.time.stringify(v))},
        {text: '', value: '', sortable: false}
      ],
      sendDialog: {
        activate: false,
        item: {}
      },
    }
  },
  computed: {
    refresh () {
      // console.log(this.$store.state.message.classRefresh)
      return this.$store.state.message.templateRefresh
    }
  },
  activated () {
    if (this.refresh) {
      this.$refs.templateList.refresh()
      this.$store.commit('message/setTemplateRefresh', false)
    }
  },
  methods: {
    async getTemplateList ({pagination, sortStack, filterItems, search}) {
      let url = '/messageApi/admin/getMsgTmplt'
      let {items, amount} = await this.$store.dispatch('message/getList', {pagination, sortStack, filterItems, search: {key: 'name', value: search}, url: url})
      return {items, amount}
    },
    addTemplate () {
      this.$router.push({name: 'newMessageTemplate'})
    },
    async deleteTemplateConfirm (item) {
      let {res, close} = await this.$L.confirm({
        title: '确认删除该消息模板？',
        text: '模板名称:' + item.name
      })
      if (res) {
        try {
          await this.deleteTemplate(item)
        }
        catch (e) {
          this.$L.alert('error', e.message)
        }
      }
      close()
    },
    async deleteTemplate (item) {
      let url = '/messageApi/admin/deleteMsgTmplt'
      let ids = []
      ids.push(item.id)
      let params = {'idList': ids}
      let res = await this.$store.dispatch('message/deleteActions', {params: params, url: url})
      if (res.data.code + '' === '200') {
        this.$L.alert('success', {message: '删除成功'})
        this.$refs.templateList.refresh()
      }
      else {
        this.$L.alert('error', {message: '删除失败，原因：' + res.data.msg})
      }
    },
    getDetails (item) {
      let selectionString = document.getSelection().toString()
      if (!selectionString) {
        this.$router.push({name: 'templateDetailBox', query: {id: item.id}})
      }
    },
    sendMessage (data) {
      console.log(data)
    }
  }
}
</script>

<style scoped>

</style>
